<template>
  <div
    :class="[
      'library-card-skeleton',
      {
        'library-card-skeleton--style': libraryType === LIBRARY_TYPE.STYLE
      }
    ]"
  >
    <div class="library-card-skeleton__favorite" />

    <div class="library-card-skeleton__image" />

    <div class="library-card-skeleton__body">
      <div class="library-card-skeleton__title" />
      <div class="library-card-skeleton__subtitle" />
      <div
        :class="[
          'library-card-skeleton__badge',
          {
            'library-card-skeleton__badge--style':
              libraryType === LIBRARY_TYPE.STYLE
          }
        ]"
      />
    </div>
  </div>
</template>

<script>
import { LIBRARY_TYPE } from '@/constants/libraryType'

export default {
  name: 'LibraryCardSkeleton',

  props: {
    libraryType: {
      type: String,
      default: LIBRARY_TYPE.BLOCK
    }
  },

  data () {
    return {
      LIBRARY_TYPE
    }
  }
}
</script>

<style lang="scss" scoped>
.library-card-skeleton {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  min-height: spacing(28);
  padding: spacing(1.5);
  overflow: hidden;
  background: $white;
  border: 1px solid rgba(0, 0, 0, 0.04);
  border-radius: spacing(0.5);
}

.library-card-skeleton__favorite {
  position: absolute;
  top: spacing(1.5);
  left: spacing(1.5);
  width: spacing(2);
  height: spacing(2);
  background: #eef1f4;
  border-radius: percentage(50);
}

.library-card-skeleton__image {
  width: 100%;
  height: spacing(20);
  margin-bottom: spacing(2);
  background: linear-gradient(90deg, #f7f8fa 25%, #f1f3f5 37%, #f7f8fa 63%);
  background-size: 400% 100%;
  border-radius: spacing(0.5);
  animation: skeleton-loading 1.6s ease infinite;
}

.library-card-skeleton__body {
  display: flex;
  flex-direction: column;
  gap: spacing(0.75);
}

.library-card-skeleton__title {
  width: percentage(70);
  height: spacing(1.5);
  background: #e9ecef;
  border-radius: spacing(0.5);
}

.library-card-skeleton__subtitle {
  width: percentage(50);
  height: spacing(1.25);
  background: #f1f3f5;
  border-radius: spacing(0.5);
}

.library-card-skeleton__badge {
  width: percentage(55);
  height: spacing(2);
  background: #eef1f4;
  border-radius: spacing(1);
}

.library-card-skeleton--style {
  height: spacing(32);
  min-height: spacing(32);
}

@keyframes skeleton-loading {
  0% {
    background-position: 100% 0;
  }

  100% {
    background-position: 0 0;
  }
}
</style>
